import { IRelocationLimit } from '@/api';
import { ClientDate, TimeSpan } from '@/core/helpers';
import { Channel } from '.';

export class RelocationLimit {

    public static fromDto(relocationLimitDto: IRelocationLimit, channels: Channel[]): RelocationLimit {

        if (!relocationLimitDto) { throw new Error('relocationLimitDto is not set'); }
        if (!relocationLimitDto.channelId || relocationLimitDto.channelId.length <= 0) {
            throw new Error('relocationLimitDto.ChannelId is not set');
        }
        if (!relocationLimitDto.date || relocationLimitDto.date.length <= 0) {
            throw new Error('relocationLimitDto.Date is not set');
        }
        if (!relocationLimitDto.duration || relocationLimitDto.duration.length <= 0) {
            throw new Error('relocationLimitDto.Duration is not set');
        }

        const id = relocationLimitDto.id;
        if (!id) {
            throw new Error(`RelocationLimit does not contains id`);
        }

        const channel = channels.find(x => x.id === relocationLimitDto.channelId);
        if (!channel) {
            throw new Error(`Can not find channel id: '${relocationLimitDto.channelId}'`);
        }

        const startDate = new ClientDate(relocationLimitDto.date);

        const duration = TimeSpan.fromDto(relocationLimitDto.duration);
        const endDate = startDate.addTimeSpan(duration);

        let volume = null;
        if (relocationLimitDto.volume || relocationLimitDto.volume === 0) {
            volume = relocationLimitDto.volume;
        }

        let weightLimit = null;
        if (relocationLimitDto.weightLimit || relocationLimitDto.weightLimit === 0) {
            weightLimit = relocationLimitDto.weightLimit;
        }

        const result = new RelocationLimit(
            id,
            channel,
            startDate,
            endDate,
            volume,
            weightLimit,
        );

        return result;
    }

    public readonly id: string;
    public readonly channel: Channel;
    public readonly startDate: ClientDate;
    public readonly endDate: ClientDate;
    public readonly volume: number | null;
    public readonly weightLimit: number | null;

    constructor(
        id: string,
        channel: Channel,
        startDate: ClientDate,
        endDate: ClientDate,
        volume: number | null,
        weightLimit: number | null,
    ) {
        this.id = id;
        this.channel = channel;
        this.startDate = startDate;
        this.endDate = endDate;
        this.volume = volume;
        this.weightLimit = weightLimit;
    }
}
